const memberInvitationStatuses = {
  accepted: { id: 'accepted', name: 'Accepted' },
  invited: { id: 'invited', name: 'Invited' },
  not_invited: { id: 'not_invited', name: 'Not Invited' },
};

export default memberInvitationStatuses;
